import { render, staticRenderFns } from "./GuarantorQuestions.vue?vue&type=template&id=d8954806&scoped=true&"
import script from "./GuarantorQuestions.vue?vue&type=script&lang=js&"
export * from "./GuarantorQuestions.vue?vue&type=script&lang=js&"
import style0 from "./GuarantorQuestions.vue?vue&type=style&index=0&id=d8954806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8954806",
  null
  
)

export default component.exports